export enum HouseSubType {
  SINGLE_FAMILY_HOUSE = 'SINGLE_FAMILY_HOUSE',
  END_TERRACE_HOUSE = 'END_TERRACE_HOUSE',
  MID_TERRACE_HOUSE = 'MID_TERRACE_HOUSE',
  SEMI_DETACHED_HOUSE = 'SEMI_DETACHED_HOUSE',
  MULTI_FAMILY_HOUSE = 'MULTI_FAMILY_HOUSE'
}
